// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function toString(payment_mode) {
  switch (payment_mode) {
    case /* Cash */0 :
        return "cash";
    case /* Online */1 :
        return "online";
    case /* Paytm */2 :
        return "paytm";
    case /* InstaMojo */3 :
        return "instamojo";
    case /* Razorpay */4 :
        return "razorpay";
    case /* BusinessAccount */5 :
        return "business_account";
    case /* Muneemji */6 :
        return "muneemji";
    
  }
}

function fromString(payment_mode) {
  switch (payment_mode) {
    case "business_account" :
        return /* BusinessAccount */5;
    case "cash" :
        return /* Cash */0;
    case "instamojo" :
        return /* InstaMojo */3;
    case "muneemji" :
        return /* Muneemji */6;
    case "online" :
        return /* Online */1;
    case "paytm" :
        return /* Paytm */2;
    case "razorpay" :
        return /* Razorpay */4;
    default:
      return ErrorUtils$Catalyst.raiseError("PaymentModeType.res", "Invalid payment mode", payment_mode);
  }
}

export {
  toString ,
  fromString ,
  
}
/* No side effect */
